<template>
  <div class="datum">
    <div class="top">
      <img :src="avatar" alt="">
      <div class="avatar">
        <p>修改头像</p>
        <label for="perImg">本地上传</label>
        <input type="file" id="perImg" @change="changeImage($event)" accept="image/gif,image/jpeg,image/jpg,image/png">
      </div>
    </div>
    <div class="content">
      <label>
        <span>姓名：</span>
        <input type="text" v-model="info.nickName">
      </label>
      <label class="sex">
        <span>性别：</span>
        <p class="man"  v-if="info.sex == 1"><img src="../../../assets/images/courier/xuanzhong.png" alt="" @click="handleClick(1)">男</p>
        <p class="man"  v-else><img src="../../../assets/images/courier/meixuan.png" alt=""  @click="handleClick(1)">男</p>
        <p class="women" v-if="info.sex == 1"><img src="../../../assets/images/courier/meixuan.png" alt=""  @click="handleClick(2)">女</p>
        <p class="women" v-else><img src="../../../assets/images/courier/xuanzhong.png" alt=""  @click="handleClick(2)">女</p>
      </label>
      <label>
        <span>生日：</span>
        <date-time @time="dateTime" :birthDay="info.birthDay" />
      </label>
      <label>
        <span>地区：</span>
        <input type="text" v-model="info.area">
      </label>
      <label>
        <span>职业：</span>
        <input type="text" v-model="info.occupation">
      </label>
      <label>
        <span>邮箱：</span>
        <input type="text" v-model="info.mail">
      </label>
      <label>
        <span>手机号：</span>
        <p ref="oldPhone">{{info.mobile}}</p>
        <button class="alter" @click="close">修改</button>
      </label>
      <button class="save" @click="save">保存</button>
    </div>
    <edit-phone v-if="isShow" @close="close" :oldMobile="info.mobile" />
  </div>
</template>

<script>
import DateTime from '../../../components/Time'
import EditPhone from '../../../components/Person/EditPhone'
import {reqChangeUserInfo, reqFileUpload} from '../../../api'
import {mapState} from 'vuex'
export default {
  data () {
    return {
      sex: 0,
      isShow: false,
      oldMobile:'',
      info:{},
      headImgUuid: '',
      avatar: ''
    }
  },
  mounted() {
    // 判断是否存在userBaseInfo
    this.isUserInfo()
  },
  methods: {
    // 判断是否存在userBaseInfo
    isUserInfo() {
      if(JSON.stringify(this.$store.state.userBaseInfo) !== '{}'){
        this.info = this.$store.state.userBaseInfo
        this.avatar = this.$store.state.userBaseInfo.headImg
      } else {
        setTimeout(() => {
          this.info = this.$store.state.userBaseInfo
          this.avatar = this.$store.state.userBaseInfo.headImg
        },500)
      }
    },
    handleClick (i) {
      this.info.sex = i
    },
    // 关闭
    close () {
      this.isShow = !this.isShow
    },
    // 获取生日时间信息
    dateTime (val) {
      this.info.birthDay = val
    },
    // 保存信息
    save () {
      if(this.info.mail){
        const reg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/
        if (!(reg.test(this.info.mail))) {
          this.$message({
            message: '邮箱格式不正确',
            type: 'error'
          })
          return false
        }
      }
      reqChangeUserInfo(this.info).then(res => {
        if(res.code === 200){
          this.$message({
            message: '保存成功',
            type: 'success'
          })
        }
      })
    },
    // 上传图片
    changeImage (e) {
      let file = e.target.files[0]
      if (file) {
        if (e.srcElement.accept.includes(file.type)) {
          const formData = new FormData()
          formData.append('file', file)
          this.avatar = window.URL.createObjectURL(e.srcElement.files.item(0))
          let config = {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
          reqFileUpload(formData).then(res => {
            if(res.code == 200) {
              this.$message({
                message: res.desc,
                type: 'success'
              })
              this.info.headImgUuid = res.result
            }
          })
        } else {
          this.$message({
            message: '图片格式不正确',
            type: 'error'
          })
        }
      }
    },
  },
  computed: {
    ...mapState(['userBaseInfo'])

  },
  components: {
    EditPhone,
    DateTime
  }
}
</script>

<style scoped lang="less" type="text/less">
.datum{
  .top{
    display: flex;
    margin-top:80px;
    padding-bottom: 30px;
    border-bottom: 1px solid #e1e1e1;
    img{
      display: block;
      width: 98px;
      height: 98px;
      border-radius: 50%;
      margin-right: 30px;
      background: #eee;
    }
    .avatar{
      width: 90px;
      text-align: center;
      p{
        margin-top:17px;
      }
      label{
        display: block;
        margin-top:15px;
        width: 90px;
        height: 36px;
        line-height: 36px;
        border:none;
        background: #2FA1DE;
        color:#fff;
        border-radius: 18px;
        cursor: pointer;
        &:focus{
          outline: none;
        }
      }
      input[type="file"]{
        display: none;
      }
    }
  }
  .content{
    margin-top:40px;
    label{
      display: flex;
      line-height: 40px;
      margin-bottom: 20px;
      span{
        display: block;
        width: 65px;
        text-align: right;
      }
      input{
        width: 340px;
        height: 40px;
        border:1px solid #e1e1e1;
        box-sizing: border-box;
        border-radius: 4px;
        text-indent: 10px;
      }
      &.sex{
        align-items: center;
        img{
          vertical-align: middle;
          margin:0 10px 0 12px;
          cursor: pointer;
        }
        P{
          margin-right:31px;
        }
      }
      .alter{
        width: 90px;
        margin-left: 123px;
        background: #F08200;
        color:#fff;
        border:none;
        border-radius: 18px;
      }
    }
    .save{
      width: 332px;
      height: 48px;
      margin: 30px 0 0 40px;
      background: #61aee6;
      font-size: 18px;
      font-weight: bold;
      color:#fff;
      border:none;
      border-radius: 24px;
      box-shadow:0px 5px 9px 0px rgba(0, 0, 0, 0.15);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Person/Children/Datum.vue